import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ProcesoFirma } from '../interfaces/datos-firma-interface';

@Injectable({
  providedIn: 'root'
})
export class ValidadoresService {

  constructor() { }

  validarRut(dato: string) {

    return ( formGroup: FormGroup ) => {
      const rutCompleto = formGroup.controls[dato];
      let rutFormateado = rutCompleto.value.replace('-', '');
      if (rutFormateado.match(/^(\d{7,8}){1}(\w{1})$/)) {
        rutFormateado = rutFormateado.replace(/^(\d{7,8})(\w{1})$/, '$1-$2');
      }

      if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test( rutFormateado )) {
        rutCompleto.setErrors({ noEsValido: true });
      } else {
        var tmp = rutFormateado.split('-');
        var digv = tmp[1]; 
        var rut = tmp[0];
        if (digv == 'K') digv = 'k';
    
        var M=0,S=1;
        for(;rut;rut=Math.floor(rut/10)) {
           S=(S+rut%10*(9-M++%6))%11;
        }    
        var digito = S ? S-1 : 'k';
  
        if (digito.toString() === digv) {
          rutCompleto.setErrors(null);
        } else {
          rutCompleto.setErrors({ noEsValido: true });
        }
      }
    }
  }

  validarEstadoDocumentoParticipante(proceso: ProcesoFirma, rutEntrante: string): string {
    // Validar para empresas con RL como emisor y receptor
    var listaParticipante = proceso.participantesProcesoFirma.filter(x => x.rut === rutEntrante) || null;

    if (listaParticipante === null) {
      return 'inexistente';  
    }

    if (proceso.estadoProcesoFirma.estatus === 'CANCELLED' && listaParticipante.filter(x => x.estatus === 'CANCELLED').length > 0) {
      return 'cancelado';
    }

    if (listaParticipante.filter(x => x.estatus === 'PENDING').length > 0) {
      return 'pendiente';
    }

    if (listaParticipante.filter(x => x.estatus === 'SIGNED').length > 0) {
      return 'firmado';
    }

    return 'pendiente';
  }
}
